<script>
import TopBar from "./components/TopBar";
import DotBar from "./components/DotBar";
import Tabs from "./components/Tabs";
import Drawer from "./components/Drawer";
import AppMenu from "./components/AppMenu";

export default {
  name: "App",
  components: {
    topbar: TopBar,
    dotbar: DotBar,
    tabs: Tabs,
    drawer: Drawer,
    "app-menu": AppMenu,
  },
};
</script>
<template>
  <div id="app">
    <drawer><app-menu /></drawer>
    <div class="app-top">
      <topbar />
    </div>
    <div class="app-center">
      <tabs />
    </div>
    <div class="app-bottom">
      <dotbar />
    </div>
  </div>
</template>
<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .app-top,
  .app-bottom {
    background: var(--background-color);
    flex: 0 0 auto;
  }

  .app-center {
    flex: 1 0 auto;
    overflow-x: hidden;
    overflow-y: scroll;
    height: calc(100% - 2 * var(--bar-height));
  }
}
</style>
